import React from "react";
import PropTypes from "prop-types";

const Tabs = (props) => {
    const { TabsHeading,onTabClick , activeTab } = props;
    return (
        <div className="profile-tabs">
            <ul
                className="nav nav-pills mb-3 profile-stepper"
                id="pills-tab"
                role="tablist"
            >
                {TabsHeading.map((val, ind) => {
                    return (
                        <li onClick={()=>onTabClick(val)} name={val} key={val} className="nav-item" role="presentation">
                            <button
                                key={ind}
                                name={val}
                                className={activeTab !== val ? "nav-link" : "nav-link active"}
                                type="button"
                                role="tab"
                            >
                                {val}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
Tabs.propTypes = {
    TabsHeading: PropTypes.arrayOf(PropTypes.string),
    onTabClick:PropTypes.func,
};

Tabs.defaultProps = {
    TabsHeading: [],
    onTabClick:()=>null
};
export default Tabs;
